export const SET_COUNT = 'SET_COUNT';
export const SET_COMPLETED = 'SET_COMPLETED';
export const SET_HOSPITAL = 'SET_HOSPITAL';
export const SET_PRIVACY_AGREEMENT = 'SET_PRIVACY_AGREEMENT';
export const SET_UI_LOADED = 'SET_UI_LOADED';
export const SET_HOSPITALS = 'SET_HOSPITALS';
export const SET_LABELS = 'SET_LABELS';
export const SET_TREATMENTS = 'SET_TREATMENTS';
export const SET_HOURLY_CHOICES = 'SET_HOURLY_CHOICES';
export const SET_STEP_STATUS = 'SET_STEP_STATUS';
export const SET_EXAM_DATA = 'SET_EXAM_DATA';
export const SET_PATIENT_DATA = 'SET_PATIENT_DATA';
export const SET_SSN_DATA = 'SET_SSN_DATA';
export const SET_SSN_PRIORITIES = 'SET_SSN_PRIORITIES';
export const SET_PRIVACY_POLICY_TEXT = 'SET_PRIVACY_POLICY_TEXT';
export const SET_CONSENTS_CONFIG = 'SET_CONSENTS_CONFIG';
export const RESET_STEP_STATUS = 'RESET_STEP_STATUS';
export const SET_SUBMIT_STATUS = 'SET_SUBMIT_STATUS';

